import { Col, Row, Tooltip } from 'antd';
import { useMemo, useState } from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';

export default function ClientSftpTable({ data }) {
    const [arrow] = useState('Show');

    const mergedArrow = useMemo(() => {
        if (arrow === 'Hide') {
            return false;
        }

        if (arrow === 'Show') {
            return true;
        }

        return {
            pointAtCenter: true,
        };
    }, [arrow]);

    const tootipText = (
        <ul>
            <li>• root directory = /to_defentry</li>
            <li>• account creation = /activation sub-folder</li>
            <li>• account removal = /deactivation sub-folder</li>
        </ul>
    );
    return (
        <div className="details-table">
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Name
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {data?.name || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Base URL
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell">
                            {data?.base_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Login
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell">
                            {data?.login || ''}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Password
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell">
                            {data?.password || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            B2C URL
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell">
                            {data?.create_account_b2c_url || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            B2B URL
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell">
                            {data.create_account_b2b_url || ''}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Mail sender address
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell">
                            {data?.mail_from_address || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Mail sender name
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell">
                            {data?.mail_from_name || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Mail recipient
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell">
                            {data?.mail_recipient || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            SFTP host
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell">
                            {data?.sftp_host || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            SFTP port
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell">
                            {data?.sftp_port || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            SFTP username
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell">
                            {data?.sftp_username || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            SFTP password
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell">
                            {data?.sftp_password || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            SFTP directory{' '}
                            <Tooltip
                                placement="top"
                                title={tootipText}
                                arrow={mergedArrow}
                                overlayClassName="ant-tooltip-custom"
                            >
                                <QuestionCircleOutlined />
                            </Tooltip>
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell">
                            {data?.sftp_directory || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
